import { render, staticRenderFns } from "./ServiceViewStatistics.vue?vue&type=template&id=2ec024e0&scoped=true"
import script from "./ServiceViewStatistics.vue?vue&type=script&lang=js"
export * from "./ServiceViewStatistics.vue?vue&type=script&lang=js"
import style0 from "./ServiceViewStatistics.vue?vue&type=style&index=0&id=2ec024e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec024e0",
  null
  
)

export default component.exports